/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![ChatCheckIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAABl0lEQVR4nN2Vu04CURCGUbzE0gT1cWgxnDkziMeZJdQUvIAlD6CJrZ2NVj6DhZUWUnhpxHtiawyJEUJiMGfZJcqu7AJL40mm2Zzz/Zl//smmUv/6VCqVeSDZApRDjdwAlE9N3NQkd/abQqdo74wFB2LUJC+apDu0kJ+1Fj0Ke0YT70WCabB4t1arzUbSx4NLX2Q4XMvm+HBxS6FDofBcLrcIJE+TCmiSR2PMQkAAkUsJwLteF8WAABAfJyUAJEdBAZT7pAQ0ciM4YORWYgLEzZB4SjtBgY+pWgQot9McchtIyiEC4owMQu4MDLeliNctL5vNztnd6gvY5YizaIDyZnNujElbgEKn6s4PuQUFyblLa8yKRqlrkteBOfB2dMZ5Y7B7RU7Wlg8H4qteR1LvXyoUyqsa+SHKFmNM2kvdAZCc2ne/GXLtJelSKSfj27MExOfR9nDH91Ujn3igGwBZ+xPuJWg/7nAVOlXXFuVkLMgX6VUI3Gt3B5C/YmWc+N3/TebzpWUgvvixYEH4pMcCXXtRzhKHxznfEQGlpANA9OIAAAAASUVORK5CYII=)
 */
export const ChatCheckIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M12.66 21.98c.4-.03.56-.51.28-.8l-.06-.06a3 3 0 1 1 4.24-4.24l.53.52c.2.2.5.2.7 0l2.53-2.52a3 3 0 0 1 .64-.5c.14-.07.24-.2.27-.34a10 10 0 1 0-18.24 3.32c.13.19.11.44-.04.61l-2.06 2.37A1 1 0 0 0 2.2 22H12c.22 0 .44 0 .66-.02Z"
        className={colorClass}
      />
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M23.7 17.7a1 1 0 1 0-1.4-1.4L18 20.58l-2.3-2.3a1 1 0 0 0-1.4 1.42l3 3a1 1 0 0 0 1.4 0l5-5Z"
        className={colorClass}
      />
    </svg>
  );
};
